import { render, staticRenderFns } from "./AcademicPerformanceEvaluationGeneralInfoForm.vue?vue&type=template&id=3e859136&scoped=true"
import script from "./AcademicPerformanceEvaluationGeneralInfoForm.vue?vue&type=script&lang=js"
export * from "./AcademicPerformanceEvaluationGeneralInfoForm.vue?vue&type=script&lang=js"
import style0 from "./AcademicPerformanceEvaluationGeneralInfoForm.vue?vue&type=style&index=0&id=3e859136&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e859136",
  null
  
)

export default component.exports